import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 1120px;
`;

const Th80 = styled(ThItem)`
  width: 80px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th120>報價單名稱</Th120>
        <Th120>報價單類型</Th120>
        <Th80>筆數</Th80>
        <Th120>報價金額</Th120>
        <Th120>議價金額</Th120>
        <Th120>報價總監</Th120>
        <Th120>建立日期</Th120>
        <Th120>修改日期</Th120>
        <Th120></Th120>
        <Th80></Th80>
      </TableRow>
    </THead>
  );
};

export default Header;
